import Services from './index.service';

import buildQuery from 'odata-query';

import { IRequestConfig } from 'models/Axios';
import { ISubsidiary } from 'models/Subsidiary';

export default class SubsidiaryServices extends Services<any, ISubsidiary> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  get = (currentPage?: number, pageSize?: number, orderby?: string, filter?: {}) => {
    const skip = currentPage || 0;
    const top = pageSize || 1000;
    const order = orderby ? `${orderby}` : undefined;   
    const filterQuery = buildQuery({ filter: filter });

    let config: IRequestConfig<ISubsidiary> = {
      url: `/subsidiary${filterQuery}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order
      },
    };

    return this.httpRequest(config);
  };
}
